(() => {
  const root = document.querySelector('[data-diy-upgrade]');
  if (!root) return;
  const header = document.querySelector('.section-header');
  const setAnchorOffset = () => root.style.setProperty('--du-anchor-offset', `${Math.ceil(header?.getBoundingClientRect().height || 0) + 24}px`);
  setAnchorOffset();
  if (header) new ResizeObserver(setAnchorOffset).observe(header);
  const filters = root.querySelector('.diy-upgrade__filters');
  const mobile = matchMedia('(max-width: 767px)');
  const setFilterDisclosure = () => { filters.open = !mobile.matches; };
  setFilterDisclosure();
  mobile.addEventListener('change', setFilterDisclosure);
  root.querySelectorAll('[data-diy-preserve-view]').forEach(link => {
    const url = new URL(link.href, location.origin);
    url.searchParams.set('view', 'diy-upgrade-20261010');
    link.href = url.href;
  });
  root.querySelector('#DiySort').addEventListener('change', () => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', root.querySelector('#DiySort').value);
    url.searchParams.set('view', 'diy-upgrade-20261010');
    url.searchParams.delete('page');
    url.hash = 'DiyProductGrid';
    location.assign(url.href);
  });
  root.querySelector('#DiyFilterForm').addEventListener('submit', event => {
    event.preventDefault();
    const url = new URL(location.href);
    [...url.searchParams.keys()].filter(key => key.startsWith('filter.') || key === 'page' || key === 'sort_by' || key === 'view').forEach(key => url.searchParams.delete(key));
    for (const [key, value] of new FormData(event.currentTarget)) {
      if (String(value).trim()) url.searchParams.append(key, value);
    }
    url.hash = 'DiyProductGrid';
    location.assign(url.href);
  });
})();
